export const ADVERSE_ACTION_CREATE = "ADVERSE_ACTION_CREATE";
export const ADVERSE_ACTION_CREATE_SUCCESS = "ADVERSE_ACTION_CREATE_SUCCESS";
export const ADVERSE_ACTION_CREATE_FAIL = "ADVERSE_ACTION_CREATE_FAIL";

export const GET_ADVERSE_ACTION_DETAILS = "GET_ADVERSE_ACTION_DETAILS";
export const GET_ADVERSE_ACTION_DETAILS_SUCCESS = "GET_ADVERSE_ACTION_DETAILS_SUCCESS";
export const GET_ADVERSE_ACTION_DETAILS_FAIL = "GET_ADVERSE_ACTION_DETAILS_FAIL";

export const UPDATE_ADVERSE_ACTION = "UPDATE_ADVERSE_ACTION";
export const UPDATE_ADVERSE_ACTION_SUCCESS = "UPDATE_ADVERSE_ACTION_SUCCESS";
export const UPDATE_ADVERSE_ACTION_FAIL = "UPDATE_ADVERSE_ACTION_FAIL";

export const DELETE_ADVERSE_ACTION = "DELETE_ADVERSE_ACTION";
export const DELETE_ADVERSE_ACTION_SUCCESS = "DELETE_ADVERSE_ACTION_SUCCESS";
export const DELETE_ADVERSE_ACTION_FAIL = "DELETE_ADVERSE_ACTION_FAIL";

export const RESET = "RESET";
export const RESET_ADVERSE_ACTION_CREATE = "RESET_ADVERSE_ACTION_CREATE";
export const RESET_ADVERSE_ACTION_DETAILS = "RESET_ADVERSE_ACTION_DETAILS";
export const RESET_ADVERSE_ACTION_DELETE = "RESET_ADVERSE_ACTION_DELETE";